import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet-async";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { main_paige_title } from "../../constants/constants";
import { setCartItems } from "../../store/actions";

/* ?payment_intent=pi_3NznmpEX8dQuA3Vr0M2dDBHI&payment_intent_client_secret=pi_3NznmpEX8dQuA3Vr0M2dDBHI_secret_EzGnajfvcEuUkHgLVORf6ym31&redirect_status=succeeded */

const PaymentInfoPage = () => {
  const dispatch = useDispatch();

  const [paymentStatus, setPaymentStatus] = useState("");
  const [transactionId, setTransactionId] = useState("");

  useEffect(() => {
    // Get all URL params
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    setTransactionId(urlParams.get("payment_intent"));
    // const payment_intent_client_secret = urlParams.get("payment_intent_client_secret");
    setPaymentStatus(urlParams.get("redirect_status"));

    // Remove product from carts
    if (urlParams.get("redirect_status") === "succeeded") {
      dispatch(setCartItems([]));
    }
  }, []);

  return (
    <div>
      <Helmet>
        <title>{main_paige_title} - Payment Info </title>
      </Helmet>
      <Header />
      <main id="content">
        <section className="pt-12 pb-10">
          <div className="container">
            <h2 className="fs-sm-40 mb-3 text-center">Payment Info</h2>
          </div>
        </section>
        <div className="pb-7">
          <div className="container">
            <div className="row no-gutters">
              <div className="col text-center">
                {paymentStatus && paymentStatus === "succeeded" && <h2 className="fs-24 mb-2">We would love to inform that payment was successfully finished</h2>}
                {paymentStatus && paymentStatus !== "succeeded" && <h2 className="fs-24 mb-2">Payment was not successfully finished</h2>}
                <p> Transaction ID : {transactionId}</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PaymentInfoPage;
